import styled from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'
import {
  Card,
  Container as ProfileContainer
} from '../Profile/Profile.styles'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const twoColumnQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridSmallUp
})

export const MusicHeroBanner = styled.div`
  margin-top: 24px;
  background: linear-gradient(87deg, #2d5cb3 -16.6%, #123569 59.57%);
  border-radius: 8px 8px 0 0;
  display: flex;
  height: 124px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

export const RequestMoreMusicContainer = styled(Card)`
  padding-top: 24px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`

export const RequestButton = styled(Tonality.Button)`
  margin-top: 24px;
`

export const AccountDetailsColumn = styled.div`
  box-sizing: border-box;
  min-height: 1px;
  min-width: 0;
  padding: 0 16px;
`

export const AccountDetailsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  margin-right: -16px;
  margin-left: -16px;
  max-height: 70px;
`

export const AccountDetailsGrid = styled.div`
  display: grid;
  gap: 24px;
`

export const AccountManagementRoot = styled(ProfileContainer)`
  @media ${twoColumnQuery} {
    ${AccountDetailsRow} {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }

    ${AccountDetailsColumn}:first-child {
      grid-column: span 4;
    }

    ${AccountDetailsColumn}:last-child {
      grid-column: span 8;
    }
  }

  @media ${mobileQuery} {
    ${MusicHeroBanner} {
      border: ${({ theme }) => `1px solid ${theme.colors.player50}`};
      border-bottom: none;
    }

    ${RequestMoreMusicContainer} {
      border: ${({ theme }) => `1px solid ${theme.colors.player50}`};
      border-top: none;
      padding: 24px 16px;
    }

    ${RequestButton} {
      width: 100%;
    }
  }
`
